import { render, staticRenderFns } from "./SelectFilterComponent.vue?vue&type=template&id=672cdeb7&scoped=true&"
import script from "./SelectFilterComponent.vue?vue&type=script&lang=js&"
export * from "./SelectFilterComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectFilterComponent.vue?vue&type=style&index=0&id=672cdeb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cdeb7",
  null
  
)

export default component.exports